export default __webpack_public_path__ + "static/media/book.0a53608a.png";